import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { Stack, styled } from "@mui/material";
import { useEffect, useRef } from "react";
import { getProductHandoutType } from "src/api/product";
import useHandoutProductStore from "src/store/relatedProduct";
import AddToCartTab from "./AddToCartTab";
import { useLegacyAddCart } from "./legacy/useLegacyAddCart";
import useLegacyCouponReceive from "./legacy/useLegacyCouponReceive";
import { useLegacyPassLogic } from "./legacy/useLegacyPassLogic";
import NoPassUsageTab from "./NoPassUsageTab";
import PassUsageTab from "./PassUsageTab";
import { usePurchaseStore } from "./purchaseStore";
import useEntitlementsQuery from "./useEntitlementsQuery";
const PurchaseToggleGroup = styled(Stack)((param)=>{
    let { theme  } = param;
    return {
        width: "100%",
        backgroundColor: theme.palette.grey[50],
        flexDirection: "row",
        borderRadius: "6px",
        padding: theme.spacing(0.25)
    };
});
const PurchaseToggleButton = styled("button", {
    shouldForwardProp: (prop)=>prop !== "active"
})((param)=>{
    let { theme , active  } = param;
    return {
        all: "unset",
        color: active ? theme.palette.grey[700] : theme.palette.grey[500],
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: 600,
        lineHeight: "24px",
        letterSpacing: "-0.16px",
        width: "100%",
        textAlign: "center",
        padding: theme.spacing(1.25, 0),
        borderRadius: "4px",
        boxShadow: active ? "3px 3px 12px 0px rgba(28, 31, 46, 0.06)" : "none",
        backgroundColor: active ? theme.palette.common.white : "transparent",
        boxSizing: "border-box",
        cursor: "pointer",
        "&:hover": {
            backgroundColor: active ? theme.palette.common.white : "transparent"
        }
    };
});
const PurchaseTabs = (param)=>{
    let { isLoggedIn , product , fullWidth  } = param;
    const hasChangedTab = useRef(false);
    const { handleAddCartClick  } = useLegacyAddCart({
        product,
        isLoggedIn
    });
    const { handleUsePass  } = useLegacyPassLogic({
        product
    });
    const { handoutCoupons  } = useLegacyCouponReceive({
        id: product.id,
        price: product.price
    });
    const { selectedTab , setSelectedTab , setFlags  } = usePurchaseStore((state)=>({
            setFlags: state.setFlags,
            selectedTab: state.selectedTab,
            setSelectedTab: state.setSelectedTab
        }));
    const { selectedPurchaseOption  } = useHandoutProductStore((state)=>({
            selectedPurchaseOption: state.selectedPurchaseOption
        }));
    const handoutType = getProductHandoutType(product);
    const { data: passes , isLoading  } = useEntitlementsQuery({
        productId: product.id,
        isLoggedIn,
        freepassOnly: handoutType === "freepass",
        selectedPurchaseOption: selectedPurchaseOption,
        productHandoutType: handoutType
    });
    useEffect(()=>{
        if (hasChangedTab.current) return;
        if (!passes) return;
        var _passes_some;
        const hasAvailablePass = (_passes_some = passes === null || passes === void 0 ? void 0 : passes.some((pass)=>!pass.isDisabled)) !== null && _passes_some !== void 0 ? _passes_some : false;
        if (hasAvailablePass) {
            setSelectedTab("pass");
        } else {
            setSelectedTab("cart");
        }
        hasChangedTab.current = true;
    }, [
        passes
    ]);
    const handleCouponClick = ()=>{
        if (!isLoggedIn) setFlags({
            showSignInModal: true
        });
        else setFlags({
            showCouponModal: true
        });
    };
    const renderPassTabContent = ()=>{
        const hasNoPasses = !isLoggedIn || isLoading || !passes || passes.length === 0;
        if (hasNoPasses) {
            return /*#__PURE__*/ _jsx(NoPassUsageTab, {
                product: product,
                hasNoPasses: true
            });
        }
        const hasNoUsablePasses = passes.every((pass)=>pass.isDisabled);
        if (hasNoUsablePasses) {
            return /*#__PURE__*/ _jsx(NoPassUsageTab, {
                product: product,
                hasNoPasses: false
            });
        }
        return /*#__PURE__*/ _jsx(PassUsageTab, {
            passes: passes,
            onClick: handleUsePass,
            fullWidth: fullWidth
        });
    };
    // cart가 기본 선택되는 탭
    const isCartTabActive = selectedTab === "cart" || selectedTab === null;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(PurchaseToggleGroup, {
                children: [
                    /*#__PURE__*/ _jsx(PurchaseToggleButton, {
                        active: selectedTab === "pass",
                        onClick: ()=>{
                            setSelectedTab("pass");
                            //mx-134
                            mixpanelEvent("Tab UI Clicked", {
                                "Tab Type": "purchase module",
                                "Tab Name": "이용권 사용"
                            });
                        },
                        children: "이용권 사용"
                    }),
                    /*#__PURE__*/ _jsx(PurchaseToggleButton, {
                        active: isCartTabActive,
                        onClick: ()=>{
                            setSelectedTab("cart");
                            //mx-134
                            mixpanelEvent("Tab UI Clicked", {
                                "Tab Type": "purchase module",
                                "Tab Name": "자료 구매"
                            });
                        },
                        children: "자료 구매"
                    })
                ]
            }),
            selectedTab === "pass" && renderPassTabContent(),
            isCartTabActive && /*#__PURE__*/ _jsx(AddToCartTab, {
                onClick: handleAddCartClick,
                isHandoutCoupons: handoutCoupons,
                onCouponClick: handleCouponClick
            })
        ]
    });
};
export default PurchaseTabs;
